//* xlsx
import { utils, writeFile } from "xlsx";
//* 组件库
import { $loading, $message } from "various-ui";
//* 公共组件
import type { DiagramsOption } from "@/components/visualizations/diagrams/default";
//* 工具函数
import { Formats } from "@/assets/js";

export const useComposable = () => {
    //* 获取翻译文本
    const i18n = useI18n();
    //* 静态变量
    const vars: { timeout?: NodeJS.Timeout; option: DiagramsOption[] } = {
        option: [
            { key: "name", name: "Query", control: "sort" },
            { key: "score", name: "Score", control: "sort" },
            { key: "start", name: "Start" },
            { key: "end", name: "End" },
            { key: "size", name: "Size", control: "sort" },
            { key: "identity", name: "Identity", control: "sort" },
            { key: "chrom", name: "Chrom" },
            { key: "strand", name: "Strand" },
            { key: "chrom_start", name: "Start" },
            { key: "chrom_end", name: "End" },
            { key: "span", name: "Span" },
        ],
    };

    //* 响应式变量
    const refs = {
        data: ref<any[]>([]),
        sort: ref<{ key: string; value: string }>({ key: "", value: "" }),
        keyword: ref<string>(""),
    };

    //* 函数列表
    const methods = {
        //* 获取数据
        data: (id: string) => {
            $loading.open({ message: i18n.t("UnderLoad") });
            vars.timeout = setInterval(() => {
                api.frontend("/api/bio/blat", {
                    data: { id: id },
                    error: () => methods.close(),
                    success: (response) => {
                        if (response.state == "SUCCESS") {
                            //* 数据缓存
                            refs.data.value = response.result || [];
                            //* 关闭定时器
                            methods.close();
                        } else if (response.state == "ENDING" || response.state == "FAILURE") {
                            $message.error(i18n.t("UnknownError"));
                            methods.close();
                        }
                    },
                });
            }, 3000);
        },

        //* 排序函数
        sort: (result: { sort?: { key: string; value: string } }) => {
            refs.sort.value.key = result.sort?.key || "";
            refs.sort.value.value = result.sort?.value || "";
        },

        //* 关闭加载器
        close: () => {
            vars.timeout && clearInterval(vars.timeout);
            vars.timeout = undefined;
            $loading.close();
        },

        //* 下载功能
        download: () => {
            const result: any = [];
            computeds.data.value.forEach((value: any) => {
                result.push({
                    Query: value.name,
                    Seq: value.sequence,
                    Score: value.score,
                    QueryStart: value.start,
                    QueryEnd: value.end,
                    Size: value.size,
                    Identity: value.identity,
                    Chrom: value.chrom,
                    Strand: value.strand,
                    Start: value.chrom_start,
                    End: value.chrom_end,
                    Span: value.span,
                });
            });

            const shell = utils.json_to_sheet(result);
            const work = utils.book_new();
            utils.book_append_sheet(work, shell, "datas");
            writeFile(work, "download.xlsx", { bookType: "xlsx", type: "buffer" });
        },
    };

    //* 计算属性
    const computeds = {
        data: computed(() => {
            return Formats.filter(refs.data.value, refs.sort.value.key, refs.sort.value.value, refs.keyword.value, [
                "end",
                "size",
                "name",
                "span",
                "score",
                "start",
                "chrom",
                "strand",
                "identity",
                "chrom_end",
                "chrom_start",
            ]);
        }),
    };

    return { vars, refs, methods, computeds };
};
